import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Nav from "./Nav";
import DropdownRight from "./DropdownRight";
import http from "../services/http";
import { FaUserEdit, FaTrash } from "react-icons/fa";
import { Space, Table } from "antd";
import Modal from "react-bootstrap/Modal";
import { SpinnerCircular } from "spinners-react";

const SearchApp = ({ data, loading, pagen, lastPage, deleteConfirmation }) => {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  let parentsList = data;

  const handleChange = (event) => {
    let searchValue = event.target.value;
    setPage(0);
    setSearch(searchValue);
  };
  const handlePage = (page) => {
    setPage(page);
  };

  let searchString = search.trim().toLowerCase();

  if (searchString.length > 0) {
    parentsList = parentsList.filter(
      (e) =>
        e?.firstname?.toLowerCase().includes(searchString) ||
        e?.email?.toLowerCase().includes(searchString) ||
        e?.phone?.toLowerCase().includes(searchString)
    );
  }

  return (
    <div className="wrapper">
      <Nav />
      <div id="content">
        <header>
          <div className="dashboard_header">
            <div className="left-side d-flex ">
              {" "}
              <button
                type="button"
                id="sidebarCollapse"
                className="btn btn-link bt_none"
              >
                <i className="fa fa-align-left"></i>{" "}
              </button>
              <h1>Parents</h1>
            </div>
            <div className="user_profile">
              <DropdownRight />
            </div>
          </div>
        </header>
        <UserInput
          update={(e) => handleChange(e)}
          handlePage={(page) => handlePage(page)}
        />
        <TableComponent
          data={parentsList}
          loading={loading}
          page={page}
          handlePage={(page) => handlePage(page)}
          lastPage={lastPage}
          lastPageNumber={pagen}
          deleteConfirmation={deleteConfirmation}
        />
      </div>
    </div>
  );
};

const TableComponent = ({ deleteConfirmation, loading, data }) => {
  const columns = [
    {
      title: "Name",
      dataIndex: "firstname",
      key: "name",
      width: "25%",
      // render: (text) => <a>{text}</a>
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "Email",
      width: "30%",
    },
    {
      title: "Phone",
      dataIndex: "phone",
      width: "20%",
      key: "Phone",
    },
    {
      title: "Gender",
      dataIndex: "gender",
      key: "Gender",
      width: "10%",
    },
    {
      title: "Total Swimmers",
      dataIndex: "swimmerCount",
      key: "swimmerCount",
      width: "5%",
    },
    {
      title: "Action",
      key: "action",
      width: "10%",
      render: (_, record) => (
        <Space size="middle">
          <Link
            to="/editParentDetails"
            state={{
              id: record.id,
              name: `${record.firstname} ${record.lastname}`,
              swimmer: record,
            }}
          >
            <FaUserEdit style={{ fontSize: "30px" }} />
          </Link>
          {/* <button
            type="button"
            id="sidebarCollapse"
            className="btn bt_none"
          > */}
          <FaTrash
            onClick={() =>
              deleteConfirmation(
                record.id,
                `${record.firstname} ${record.lastname}`
              )
            }
            style={{ fontSize: "30px" }}
          />
          {/* </button> */}
        </Space>
      ),
    },
  ];

  return (
    <div className="table_vedio_upload dashbord_table team_table mb_30 over_flow mb-0">
      <Table
        className="table table-borderless table-responsive-md"
        columns={columns}
        // rowSelection={{ ...rowSelection, checkStrictly }}
        dataSource={data}
        loading={loading}
        pagination={{ defaultPageSize: 20 }}
      />
    </div>
  );
};

const UserInput = ({ update, handlePage }) => {
  return (
    <div className="analysts-wraper-head">
      <div className="form-group search_wraper">
        <input
          onChange={(e) => {
            update(e);
            handlePage(0);
          }}
          name=""
          className="form-control custom_input"
          placeholder="Search by Name, Email and Phone "
        />
      </div>
      <div className="map_btn">
        <Link
          to="/editParentDetails"
          state={{
            id: undefined,
            name: ``,
            swimmer: {},
          }}
          className="them_btn"
        >
          Add New Parent
        </Link>
      </div>
    </div>
  );
};

export default function Parent() {
  const token = localStorage.getItem("xAuthToken");
  const [team, setTeam] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [lastPageNumber, setLastPageNumber] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const usersPerPage = 7;

  const [parentsID, setParentsID] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const handleClose = () => setShowModal(false);
  const [deleteMessage, setDeleteMessage] = useState(
    "are you sure you want to delete?"
  );

  const deleteConfirmation = (id, name) => {
    setParentsID(id);
    setDeleteMessage(
      `Every Swimmer associated with ${name} will be deleted. Are you sure you want to delete ${name}?`
    );
    setShowModal(true);
  };

  const DeleteParent = async () => {
    setLoading(true);

    http
      .delete(`api/admin/parent/${parentsID}?token=${token}`)
      .then((res) => {
        setParentsID(0);
        setLoading(false);
        GetAllParent();
        handleClose();
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    GetAllParent();
  }, []);

  const GetAllParent = async () => {
    setLoading(true);

    http
      .get(`api/admin/parent/getallparents?token=${token}`)
      .then((res) => {
        setLoading(false);
        setTeam(res.data);
        setLastPageNumber(res.data.length % usersPerPage);
        setLastPage(Math.ceil(res.data.length / usersPerPage));
      })
      .catch((error) => {
        setLoading(false);
        if (error.response) {
          if (error.response.data.errors) {
            for (let key in error.response.data.errors) {
              setError(error.response.data.errors[key]);
            }
          } else if (error.response.data.message) {
            setError(error.response.data.message);
          }
        }
      });
  };
  return (
    <>
      <SearchApp
        data={team}
        loading={loading}
        pagen={lastPageNumber}
        lastPage={lastPage}
        deleteConfirmation={deleteConfirmation}
      />
      <Modal className="starrating" show={showModal} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title as="h5">Are you sure?</Modal.Title>
          <button
            onClick={handleClose}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            {" "}
            <span aria-hidden="true">&times;</span>{" "}
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="raing_star">
            <p>{deleteMessage}</p>
          </div>
          <div className="modal-footer border-top-0">
            <button
              onClick={handleClose}
              type="button"
              className=" them_btn_ouline  "
            >
              Cancel
            </button>
            <button
              onClick={DeleteParent}
              disabled={loading}
              type="button"
              className="them_btn1 "
              data-toggle="modal"
              data-target="#new_team_add_yes"
            >
              {loading ? <SpinnerCircular /> : " Yes"}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
